var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"title bg-color text-on-bg mt-5",attrs:{"rounded":"","large":""},on:{"click":_vm.setLogInModal}},[_vm._v(" PLEASE SIGN UP FIRST! ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }